import React from "react";
import { useEffect, useRef } from "react";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import { BotonPrincipal } from "../componentes/btn";
import { CarouselReferencias } from "../componentes/carouselReferencias";
import { CarouselProductos } from "../componentes/carouselProductos";
import { Contacto } from "../componentes/contacto";
import CountersSection from "../componentes/CountersSection";
import { BotonFlotante } from "../componentes/btnFlotante";
import { NavComponent } from "../componentes/navComponent";
import { ReactComponent as ValoresIcon } from "../img/home/quienes-somos/valores.svg";
import { ReactComponent as MisionIcon } from "../img/home/quienes-somos/mision.svg";
import { ReactComponent as EquipoIcon } from "../img/home/quienes-somos/equipo.svg";
import { ReactComponent as SoftwareIcon } from "../img/home/servicios/software.svg";
import { ReactComponent as InfraestructuraIcon } from "../img/home/servicios/infraestructura.svg";
import { ReactComponent as SeguridadIcon } from "../img/home/servicios/seguridad.svg";
import { ReactComponent as ConsultoriaIcon } from "../img/home/servicios/consultoria.svg";
import ipecus from "../img/home/productos/ipecus-blanco.svg";
import owltrack from "../img/home/productos/owltrack-blanco.svg";
import argefix from "../img/home/productos/argefix-blanco.svg";
import mundopiloto from "../img/home/productos/mundoPiloto-blanco.svg";
import neurolog from "../img/home/productos/neurolog-blanco.svg";
import productoNeurolog from "../img/home/productos/producto-neurolog.svg";
import { Row, Col, Card, Carousel } from "antd";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const productoIpecus = process.env.PUBLIC_URL + "/img/productos/producto-ipecus.svg";
const productoOwltrack = process.env.PUBLIC_URL + "/img/productos/producto-owltrack.svg";
const productoArgefix = process.env.PUBLIC_URL + "/img/productos/producto-argefix.svg";
const productoMundopiloto = process.env.PUBLIC_URL + "/img/productos/producto-mundoPiloto.svg";

export const Home = () => {
  const carouselRef = useRef(null);
 const carouselTelRef = useRef();
  useEffect(() => {
    const interval = setInterval(() => {
      if (carouselRef.current) {
        carouselRef.current.next();
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);
  function isSafari() {
    return (
      /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
      !/CriOS|FxiOS/i.test(navigator.userAgent)
    );
  }

  return (
    <>
      <NavComponent />
      <BotonFlotante />
      {/*Header*/}
      <section
        id="header"
        className="animate-slide-in"
        style={{
          height: "130vh",
        }}
      >
        <Row
          gutter={[16, 16]}
          style={{
            margin: 0,
            padding: 0,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Col
            className="col-responsive"
            xs={24}
            sm={12}
            md={12}
            lg={12}
            xl={11}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              height: "100vh",
            }}
          >
            <h1 className="titulos">Transformamos ideas </h1>
            <div className="typewriter-container titulos">
              <h1 className="typewriter">en soluciones integrales</h1>
            </div>

            <h5 className="subtitulos">
              Nos dedicamos a la puesta en marcha de soluciones integrales para
              empresas y profesionales. Somos expertos en desarrollos web,
              aplicaciones móviles y proyectos de infraestructura, seguridad e
              IoT
            </h5>
            <br />
            <BotonPrincipal
              text="Más información"
              colorFondo="#ffffff"
              colorTexto="#175E6A"
              className="boton-principal-desarrollo boton-centrado"
              style={{
                display: "inline-block",
                padding: "10px 20px",
                textAlign: "center",
                alignSelf: "start",
              }}
              onClick={() => {
                const section = document.getElementById("contacto");
                section?.scrollIntoView({ behavior: "smooth" });
              }}
            />
          </Col>
          <Col
            className="col-responsive"
            xs={24}
            sm={12}
            md={12}
            lg={12}
            xl={11}
            style={{
              display: "flex",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <DotLottieReact
              src="https://lottie.host/41bf0156-2cde-4c8b-b01a-81539b9e2c04/b3vH6VY6Du.lottie"
              loop
              autoplay
              className="lottie-header"
              style={{
                maxWidth: "14em",
                maxHeight: "auto",
                width: "14em",
                height: "auto",
              }}
            />
          </Col>
        </Row>
      </section>

      {/*Quiénes somos*/}
      <section
        id="quienesSomos"
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <h1 className="titulos-degrade">
          <b>Especialistas </b>en transformar ideas con <b>tecnología</b>
        </h1>
        <h5
          className="subtitulos-principales"
          style={{
            textAlign: "center",
            margin: "0 auto",
            maxWidth: "80%",
            wordWrap: "break-word",
          }}
        >
          Hacemos foco en el usuario, apostando por soluciones que potencian la
          eficiencia y mejoran los procesos. Diseñamos con la mirada en el
          usuario final, construyendo experiencias desde la usabilidad
        </h5>
        <br />
        <Row gutter={[12, 12]} justify="center">
          {" "}
          <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: "16px" }}>
            {" "}
            <Card
              title={
                <div style={{ position: "relative", height: "150px" }}>
                  <ValoresIcon
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.8em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      color: "#000",
                      zIndex: 2,
                    }}
                  />
                  <DotLottieReact
                    src="https://lottie.host/855ccafd-604c-4a34-a52b-dc3a207fae2e/MvaQq7RdTi.lottie"
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "54%",
                      left: "50%",
                      width: "8em",
                      height: "8em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              style={{
                position: "relative",
                overflow: "hidden",
                height: "350px",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
              }}
            >
              <h3 style={{ textAlign: "center" }} className="titulo-card">
                Valores
              </h3>
              <p className="textos-card">
                Consideramos al equipo como un todo, donde las relaciones y
                oportunidades afectan por igual a cada integrante de la empresa.
              </p>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: "16px" }}>
            {" "}
            <Card
              title={
                <div style={{ position: "relative", height: "150px" }}>
                  <MisionIcon
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.8em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      color: "#000",
                      zIndex: 2,
                    }}
                  />
                  <DotLottieReact
                    src="https://lottie.host/855ccafd-604c-4a34-a52b-dc3a207fae2e/MvaQq7RdTi.lottie"
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "8em",
                      height: "8em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              bordered={false}
              style={{
                position: "relative",
                overflow: "hidden",
                height: "350px",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
              }}
            >
              <h3 style={{ textAlign: "center" }} className="titulo-card">
                Misión
              </h3>
              <p className="textos-card">
                Potenciar la actividad de comercios, empresas y emprendedores a
                través de soluciones ágiles y sencillas.
              </p>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: "16px" }}>
            {" "}
            <Card
              title={
                <div style={{ position: "relative", height: "150px" }}>
                  <EquipoIcon
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.8em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      color: "#000",
                      zIndex: 2,
                    }}
                  />
                  <DotLottieReact
                    src="https://lottie.host/855ccafd-604c-4a34-a52b-dc3a207fae2e/MvaQq7RdTi.lottie"
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "8em",
                      height: "8em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              bordered={false}
              style={{
                position: "relative",
                overflow: "hidden",
                height: "350px",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
              }}
            >
              <h3 style={{ textAlign: "center" }} className="titulo-card">
                Equipo
              </h3>
              <p className="textos-card">
                Somos una empresa con orientación en diseño y desarrollo de
                soluciones de infraestructura y proyectos de software a medida.
              </p>
            </Card>
          </Col>
        </Row>
      </section>

      {/*Contador*/}
      <section
        id="contador"
        className="animate-slide-in"
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <CountersSection />
      </section>

      {/*Servicios*/}
      <section
        id="servicios"
        style={{
          height: "100vh",
          marginBottom: "20px",
          display: "flex",
          flexDirection: "column",
          padding: "20px",
        }}
      >
        <h1 className="titulos-degrade" style={{ textAlign: "center" }}>
          <b>Servicios</b> y <b>soluciones</b> para <br /> la{" "}
          <b>evolución digital</b> de tu <b>empresa</b>
        </h1>{" "}
        <br></br>
        <br></br>
        <Row
          gutter={[12, 12]}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Col
            xs={24}
            sm={12}
            md={6}
            lg={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              title={
                <div style={{ position: "relative", height: "100px" }}>
                  <InfraestructuraIcon
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.4em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      zIndex: 2,
                    }}
                  />
                  <DotLottieReact
                    src="https://lottie.host/1d215c14-bc5e-41a6-a9ef-f4059ad25c1a/VjFzjlFQ2e.lottie"
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "6em",
                      height: "6em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              bordered={false}
              style={{
                position: "relative",
                overflow: "hidden",
                width: "300px",
                height: "auto",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
                justifyContent: "center",
              }}
            >
              <h3 style={{ textAlign: "center" }} className="titulo-card">
                Infraestructura tecnológica
              </h3>
              <p className="textos-card">
                Diseñamos infraestructuras escalables en servidores, redes y
                almacenamiento en la nube
              </p>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "1em",
                }}
              >
                <a
                  href="/infraestructura"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BotonPrincipal
                    text="Más información"
                    colorFondo="#175E6A"
                    colorTexto="#ffffff"
                  />
                </a>
              </div>
            </Card>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={6}
            lg={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              title={
                <div style={{ position: "relative", height: "100px" }}>
                  <SoftwareIcon
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.4em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      zIndex: 2,
                    }}
                  />
                  <DotLottieReact
                    src="https://lottie.host/1d215c14-bc5e-41a6-a9ef-f4059ad25c1a/VjFzjlFQ2e.lottie"
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "6em",
                      height: "6em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              bordered={false}
              style={{
                position: "relative",
                overflow: "hidden",
                width: "300px",
                height: "auto",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
              }}
            >
              <h3 style={{ textAlign: "center" }} className="titulo-card">
                Software a <br /> medida
              </h3>
              <p className="textos-card">
                Soluciones web y aplicaciones móviles. Páginas Web Corporativas.
                <br></br>
                Foco en UI UX
              </p>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "1em",
                }}
              >
                <a href="/desarrollo" target="_blank" rel="noopener noreferrer">
                  <BotonPrincipal
                    text="Más información"
                    colorFondo="#175E6A"
                    colorTexto="#ffffff"
                  />
                </a>
              </div>
            </Card>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={6}
            lg={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              title={
                <div style={{ position: "relative", height: "100px" }}>
                  <SeguridadIcon
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.4em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      zIndex: 2,
                    }}
                  />
                  <DotLottieReact
                    src="https://lottie.host/1d215c14-bc5e-41a6-a9ef-f4059ad25c1a/VjFzjlFQ2e.lottie"
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "6em",
                      height: "6em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              bordered={false}
              style={{
                position: "relative",
                overflow: "hidden",
                width: "300px",
                height: "auto",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
              }}
            >
              <h3 style={{ textAlign: "center" }} className="titulo-card">
                Seguridad <br /> inteligente
              </h3>
              <p className="textos-card">
                Soluciones para cercos perimetrales (circuito cerrado de
                cámaras, radares, sensores)
              </p>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "1em",
                }}
              >
                <a
                  href="/infraestructura"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BotonPrincipal
                    text="Más información"
                    colorFondo="#175E6A"
                    colorTexto="#ffffff"
                  />
                </a>
              </div>
            </Card>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={6}
            lg={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              title={
                <div style={{ position: "relative", height: "100px" }}>
                  <ConsultoriaIcon
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.4em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      zIndex: 2,
                    }}
                  />
                  <DotLottieReact
                    src="https://lottie.host/1d215c14-bc5e-41a6-a9ef-f4059ad25c1a/VjFzjlFQ2e.lottie"
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "6em",
                      height: "6em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              bordered={false}
              style={{
                position: "relative",
                overflow: "hidden",
                width: "300px",
                height: "auto",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
                justifyContent: "center",
              }}
            >
              <h3 style={{ textAlign: "center" }} className="titulo-card">
                Consultoría de <br /> sistemas
              </h3>
              <p className="textos-card">
                Pensamos y diseñamos procesos junto a nuestros clientes,
                aportando la experiencia de muchos años
              </p>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "1em",
                }}
              >
                <a href="/desarrollo" target="_blank" rel="noopener noreferrer">
                  <BotonPrincipal
                    text="Más información"
                    colorFondo="#175E6A"
                    colorTexto="#ffffff"
                  />
                </a>
              </div>
            </Card>
          </Col>
        </Row>
      </section>

      {/*Productos - Pantallas grandes*/}
      <section
        id="productos"
        style={{
          height: "auto",
          marginBottom: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "Center",
          padding: "0 20px",
        }}
      > <br></br>
        <h1
          className="titulos-blancos"
          style={{ textAlign: "center", marginBottom: "1em" }}
        >
          Nuestros <b>productos</b>
        </h1>

        <CarouselProductos />
      </section>

      {/* Productos - Teléfonos */}
      <section
        id="productos-telefonos"
        className="productos-seccion text-center"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minHeight: "auto",
          alignItems: "center",
        }}
      >
        <br />
        <h1 className="titulos-blancos" style={{ textAlign: "center" }}>
          Nuestros <b>productos</b>
        </h1>
        <br />
          <button
          className="custom-arrow custom-prev"
          onClick={() => carouselTelRef.current.prev()}
          aria-label="Anterior"
        >
          <LeftOutlined />
        </button>
        <button
          className="custom-arrow custom-next"
          onClick={() => carouselTelRef.current.next()}
          aria-label="Siguiente"
        >
          <RightOutlined />
        </button>
        <Carousel ref={carouselTelRef} autoplay dots={false} arrows={false}>
          {/* Slide logos */}
          <div className="carousel-slide">
            <div style={{ width: "100%" }}>
              <Row
                gutter={[16, 16]}
                align="middle"
                justify="center"
         
              >
                <Col
                  xs={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <a
                    href="https://ipecus.com.ar/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={ipecus}
                      alt="Logo Ipecus"
                      className="image-marca logo-slide-principal"
                      style={{
                        width: "60px",
                        maxWidth: "100px",
                        height: "auto",
                      }}
                    />
                  </a>
                </Col>
                <Col
                  xs={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <a
                    href="https://owl-track.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={owltrack}
                      alt="Logo Owltrack"
                      className="image-marca logo-slide-principal"
                      style={{
                        width: "60px",
                        maxWidth: "100px",
                        height: "auto",
                      }}
                    />
                  </a>
                </Col>
                <Col
                  xs={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <a
                    href="https://www.argefix.ar/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={argefix}
                      alt="Logo Argefix"
                      className="image-marca logo-slide-principal"
                      style={{
                        width: "60px",
                        maxWidth: "100px",
                        height: "auto",
                      }}
                    />
                  </a>
                </Col>
              </Row>
              <Row gutter={[16, 16]} align="middle" justify="center">
                <Col
                  xs={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <a
                    href="https://mundopiloto.com.ar/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={mundopiloto}
                      alt="Logo Mundo Piloto"
                      className="image-marca logo-slide-principal"
                      style={{
                        width: "60px",
                        maxWidth: "100px",
                        height: "auto",
                      }}
                    />
                  </a>
                </Col>
                <Col
                  xs={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <a
                    href="https://neurolog.com.ar/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={neurolog}
                      alt="Logo NeuroLog"
                      className="image-marca logo-slide-principal"
                      style={{
                        width: "60px",
                        maxWidth: "100px",
                        height: "auto",
                      }}
                    />
                  </a>
                </Col>
              </Row>
            </div>
          </div>

          {/* Slide Ipecus */}
          <div className="carousel-slide">
            <Row gutter={8} align="middle" justify="center">
              <Col
                xs={24}
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={ipecus}
                  alt="Producto Ipecus"
                  className="image-marca"
                />
                <h5 className="subtitulos-principales-blancos">
                  Gestión de hacienda <br />
                  El software que tu campo necesita
                </h5>
                <br />
                <a
                  href="https://ipecus.com.ar/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BotonPrincipal
                    text="Ir a Ipecus"
                    colorFondo="#ffffff"
                    colorTexto="#175E6A"
                  />
                </a>
                <br />
                <img
                  src={productoIpecus}
                  alt="Producto Ipecus"
                  className="carousel-image"
                />
              </Col>
            </Row>
          </div>

          {/* Slide Owltrack */}
          <div className="carousel-slide">
            <Row gutter={8} align="middle" justify="center">
              <Col
                xs={24}
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={owltrack}
                  alt="Producto Owltrack"
                  className="image-marca"
                />
                <h5 className="subtitulos-principales-blancos">
                  Calculadora de huella de carbono <br />
                  Una plataforma digital para una comunidad responsable
                </h5>
                <br />
                <a
                  href="https://owl-track.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BotonPrincipal
                    text="Ir a Owltrack"
                    colorFondo="#ffffff"
                    colorTexto="#175E6A"
                  />
                </a>
                <br />
                <img
                  src={productoOwltrack}
                  alt="Producto Owltrack"
                  className="carousel-image"
                />
              </Col>
            </Row>
          </div>

          {/* Slide Argefix */}
          <div className="carousel-slide">
            <Row gutter={8} align="middle" justify="center">
              <Col
                xs={24}
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={argefix}
                  alt="Producto Argefix"
                  className="image-marca"
                />
                <h5 className="subtitulos-principales-blancos">
                  Software para talleres mecánicos <br />
                  Gestioná tu taller, ordená tu trabajo y el de tu equipo
                </h5>
                <br />
                <a
                  href="https://www.argefix.ar/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BotonPrincipal
                    text="Ir a Argefix"
                    colorFondo="#ffffff"
                    colorTexto="#175E6A"
                  />
                </a>
                <br />
                <img
                  src={productoArgefix}
                  alt="Producto Argefix"
                  className="carousel-image"
                />
              </Col>
            </Row>
          </div>

          {/* Slide Mundo Piloto */}
          <div className="carousel-slide">
            <Row gutter={8} align="middle" justify="center">
              <Col
                xs={24}
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={mundopiloto}
                  alt="Producto Mundo Piloto"
                  className="image-marca"
                />
                <h5 className="subtitulos-principales-blancos">
                  Solución App y Web para asociaciones
                  <br />
                  Plataforma digital para la gestión de competencias en el mundo
                  del deporte motor
                </h5>
                <br />
                <a
                  href="https://mundopiloto.com.ar/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BotonPrincipal
                    text="Ir a Mundo Piloto"
                    colorFondo="#ffffff"
                    colorTexto="#175E6A"
                  />
                </a>
                <br />
                <img
                  src={productoMundopiloto}
                  alt="Producto Mundo Piloto"
                  className="carousel-image"
                />
              </Col>
            </Row>
          </div>

          {/* Slide NeuroLog */}
          <div className="carousel-slide">
            <Row gutter={8} align="middle" justify="center">
              <Col
                xs={24}
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={neurolog}
                  alt="Producto NeuroLog"
                  className="image-marca"
                />
                <h5 className="subtitulos-principales-blancos">
                  Software para consultorios <br />
                  Solución todo en uno para profesionales
                </h5>
                <br />
                <a
                  href="https://neurolog.com.ar/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BotonPrincipal
                    text="Ir a NeuroLog"
                    colorFondo="#ffffff"
                    colorTexto="#175E6A"
                  />
                </a>
                <br />
                <img
                  src={productoNeurolog}
                  alt="Producto NeuroLog"
                  className="carousel-image"
                />
              </Col>
            </Row>
          </div>
        </Carousel>
      </section>

      {/*Referencias*/}

      <section
        id="servicios"
        style={{
          height: "100vh",
          marginBottom: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "0 20px",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Row
          gutter={[16, 16]}
          align="middle"
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            maxWidth: "1200px",
          }}
        >
          <Col
            className="col-responsive"
            xs={24}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <h1 className="titulos-degrade" style={{ textAlign: "left" }}>
              Referencias de <b> empresas</b> que confían en
              <b> nosotros</b>
            </h1>{" "}
            <br></br>
            <h5
              className="subtitulos-principales"
              style={{
                textAlign: "left",
                margin: "0 auto",
                fontWeight: "800",
              }}
            >
              Nuestros clientes confían en nuestro compromiso con la excelencia
              y la personalización, llevándonos a colaborar en proyectos de alto
              impacto
            </h5>
          </Col>
          <Col
            className="col-responsive"
            xs={24}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              marginTop: "2em",
            }}
          >
            <CarouselReferencias />
          </Col>
        </Row>
      </section>

      {/*Trabajá con nostros */}
      <section
        id="enviarCV"
        className="animate-slide-in"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          boxSizing: "border-box",
          background: "linear-gradient(90deg, #175E6A, #1B1F28)",
          padding: "0 80px",
        }}
      >
        <h1 className="titulos-blancos" style={{ textAlign: "center" }}>
          ¡Trabajá con <b>nosotros!</b>
        </h1>
        <br />
        <h1
          className="subtitulos-principales-blancos"
          style={{
            textAlign: "center",
            margin: "0 auto",
            maxWidth: "80%",
            wordWrap: "break-word",
          }}
        >
          {" "}
          Si te interesa formar parte de una empresa que está a la vanguardia de{" "}
          <br></br>
          la tecnología y la innovación, ¡Nos encantaría recibir tu postulación!{" "}
          <br></br>
          Enviá tu CV a{" "}
          <a href="mailto:RRHH@fasecuatro.com.ar?subject=Quiero%20ser%20parte%20de%20Fase%20Cuatro">
            RRHH@fasecuatro.com.ar
          </a>
          , y contános por qué te gustaría unirte a nosotros
        </h1>
        <br />
        <BotonPrincipal
          colorFondo="#ffffff"
          colorTexto="#175E6A"
          text="Enviar mi CV"
          onClick={() => {
            window.location.href =
              "mailto:RRHH@fasecuatro.com.ar?subject=Quiero%20ser%20parte%20de%20Fase%20Cuatro&body=Hola,%20me%20interesa%20formar%20parte%20de%20su%20equipo!";
          }}
        />
      </section>

      {/*Contacto*/}
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          boxSizing: "border-box",
          padding: "0 80px",
        }}
        id="contacto-footer"
        className="section-contacto-footer animate__animated animate__fadeInUp"
      >
        <Contacto tituloColor="#175E6A" botonColor={["#175E6A", " #1B1F28"]} />
      </section>
    </>
  );
};

export default Home;
